const IST_OPTS = {
  timeZone: 'Asia/Kolkata',
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: true,
};

export const fmtIST = (d) => new Date(d).toLocaleString('en-GB', IST_OPTS);
